import anime from 'animejs';
import { isMobile } from './helpers';

export default class FullScreenScroll {
	constructor() {
		this.main = document.getElementById('main');
		this.sections = document.getElementsByTagName('section');

		this.buildSections();
		this.addEvents();
		this.changeCurrentPosition(0);
		this.registerIeTags();

		this.hashChange();
	}

	private main: HTMLElement;
	private sections: HTMLCollection;

	private mTouchStart = 0;
	private mTouchEnd = 0;

	private currentPosition = 0;
	private animateFunction: string = 'ease';
	private animateTime: number = 0.8;

	currentPositionListener = (val) => {};

	set CurrentPosition(val) {
		this.currentPosition = val;
		this.currentPositionListener(val);
	}

	get CurrentPosition() {
		return this.currentPosition;
	}

	registerCurrentPositionListener = (listener) => {
		this.currentPositionListener = listener;
	}

	private buildSections = () => {
		for (let index = 0; index < this.sections.length; index++) {
			const element = this.sections[index];
			element.setAttribute('data-index', index.toString());
		}

		const sidebarListItems = document.querySelectorAll('#sidebar ul li');
		if (sidebarListItems) {
			for (let i = 0; i < sidebarListItems.length; i++) {
				(sidebarListItems[i] as HTMLElement).onclick = e => {
					const pos = (e.srcElement as HTMLElement).getAttribute('data-currentpage');
					if (pos) {
						this.changeCurrentPosition(parseInt(pos));
					}
				}
			}
		}
	}

	private addEvents = () => {
		if (document.addEventListener) {
			document.addEventListener('mousewheel', this.mouseWheelAndKey, false);
			document.addEventListener('wheel', this.mouseWheelAndKey, false);
			document.addEventListener('keyup', this.mouseWheelAndKey, false);
			document.addEventListener('touchstart', this.touchStart, false);
			document.addEventListener('touchend', this.touchEnd, false);
			window.addEventListener('hashchange', this.hashChange, false);

			/**
			 * Enable scroll if decive don't have touch support
			 */
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				if (!('ontouchstart' in window)) {
					document.body.style.overflow = 'scroll';
				}
			}

		} else {
			// attachEvent not on document.
			// document.attachEvent('onmousewheel', this.mouseWheelAndKey, false);
			// document.attachEvent('onkeyup', this.mouseWheelAndKey, false);
		}
	};

	private mouseWheelAndKey = (event: WheelEvent | KeyboardEvent) => {
		if ((event instanceof WheelEvent && event.deltaY > 0) || (event instanceof KeyboardEvent && event.keyCode === 40)) {
			this.currentPosition++;
			this.changeCurrentPosition(this.currentPosition);
		} else if ((event instanceof WheelEvent && event.deltaY < 0) || (event instanceof KeyboardEvent && event.keyCode === 38)) {
			this.currentPosition--;
			this.changeCurrentPosition(this.currentPosition);
		}
		this.removeEvents();
	}

	private touchStart = (event: TouchEvent) => {
		this.mTouchStart = event.changedTouches[0].clientY;
		this.mTouchEnd = 0;
	}

	private touchEnd = (event: TouchEvent) => {
		// event.preventDefault();
		this.mTouchEnd = event.changedTouches[0].clientY;
		// console.log(this.mTouchStart, this.mTouchEnd, this.mTouchEnd - this.mTouchStart > 100, this.mTouchStart - this.mTouchEnd > 100)
		if (this.mTouchEnd - this.mTouchStart > 100 || this.mTouchStart - this.mTouchEnd > 100) {
			if (this.mTouchEnd > this.mTouchStart) {
				this.currentPosition--;
			} else {
				this.currentPosition++;
			}
			this.changeCurrentPosition(this.currentPosition);
		}
	}

	private hashChange = (event?: Event) => {
		if (location) {
			const anchor = location.hash.replace('#', '').split('/')[0];
			if (anchor) {
				const position = parseInt(anchor);
				if (position < 0) {
					this.changeCurrentPosition(0);
				} else if (position > (this.sections.length - 1)) {
					this.changeCurrentPosition((this.sections.length - 1));
				} else {

					this.currentPosition = position;
					this.changeCurrentPosition(position);
					this.animateScroll();
				}
			}
		}
	}

	private removeEvents = () => {
		if (document.addEventListener) {
			document.removeEventListener('mousewheel', this.mouseWheelAndKey, false);
			document.removeEventListener('wheel', this.mouseWheelAndKey, false);
			document.removeEventListener('keyup', this.mouseWheelAndKey, false);
			document.removeEventListener('touchstart', this.touchStart, false);
			document.removeEventListener('touchend', this.touchEnd, false);

		} else {
			// document.detachEvent('onmousewheel', this.mouseWheelAndKey, false);
			// document.detachEvent('onkeyup', this.mouseWheelAndKey, false);
		}

		// throttle scroll on desktop
		if (isMobile) {
			this.addEvents();
		} else {
			setTimeout(() => {
				this.addEvents();
			}, 600);
		}
	};

	private animateScroll = () => {
		const animateTime = this.animateTime;
		const animateFunction = this.animateFunction;
		const position = this.currentPosition * 100;

		// if (isMobile) {
		// 	this.main.style.transform = 'translateY(-' + position + '%)';
		// 	this.main.style.webkitTransform = 'translateY(-' + position + '%)';
		// 	(this.main.style as any).mozTransform = 'translateY(-' + position + '%)';
		// 	(this.main.style as any).msTransform = 'translateY(-' + position + '%)';

		// 	this.main.style.transition = 'all ' + animateTime + 's ' + animateFunction;
		// 	this.main.style.webkitTransition = 'all ' + animateTime + 's ' + animateFunction;
		// 	(this.main.style as any).mozTransition = 'all ' + animateTime + 's ' + animateFunction;
		// 	(this.main.style as any).msTransition = 'all ' + animateTime + 's ' + animateFunction;
		// } else {
		// 	anime({
		// 		targets: '#main',
		// 		translateY: `-${position}%`,
		// 		delay: 0,
		// 		easing: 'easeInQuad',
		// 		duration: 600
		// 	})
		// }


		this.main.style.transform = 'translateY(-' + position + '%)';
		this.main.style.webkitTransform = 'translateY(-' + position + '%)';
		// (this.main.style as any).mozTransform = 'translateY(-' + position + '%)';
		// (this.main.style as any).msTransform = 'translateY(-' + position + '%)';

		this.main.style.transition = 'all ' + animateTime + 's ' + animateFunction;
		this.main.style.webkitTransition = 'all ' + animateTime + 's ' + animateFunction;
		// (this.main.style as any).mozTransition = 'all ' + animateTime + 's ' + animateFunction;
		// (this.main.style as any).msTransition = 'all ' + animateTime + 's ' + animateFunction;

		const sidebarList = document.querySelector('#sidebar > ul');
		if (sidebarList) {
			for (let i = 0; i < sidebarList.children.length; i++) {
				sidebarList.children[i].className = this.updateClass(2, 'active', sidebarList.children[i].className);
				if (i === this.currentPosition) {
					sidebarList.children[i].className = this.updateClass(1, 'active', sidebarList.children[i].className);
				}
			}
		}
	};

	private changeCurrentPosition = (position: number) => {
		const sidebarCurrentPositionEl = document.querySelector('#sidebar .current');
		const sidebarEl = document.getElementById('sidebar');
		if (position !== null) {
			this.currentPosition = position;
			this.setCurrentPosition(position);

			if (position < 0 || position > this.sections.length - 1) {
				return
			}

			const positionChar = (position + 1).toString();
			if (sidebarEl) {
				sidebarCurrentPositionEl.innerHTML = '0' + positionChar;
				sidebarEl.className = 'section-' + positionChar;
			}

			const logo = document.querySelector('.algorim.logo');
			if (logo) {
				setTimeout(() => {
					logo.setAttribute('data-section', positionChar);
				}, 250);
			}
		}
	};

	private setCurrentPosition = (pos: number) => {
		if (pos !== null) {
			if (pos < 0) {
				this.changeCurrentPosition(0);
			} else if (pos > this.sections.length - 1) {
				this.changeCurrentPosition(this.sections.length - 1);
			} else {
				this.currentPosition = pos;
				this.animateScroll();
				this.CurrentPosition = pos;
			}
		}
	};

	private registerIeTags = () => {
		document.createElement('section');
	};

	private updateClass = (type: number, newClass: string, currentClass: string) => {
		if (type === 1) {
			return currentClass += ' ' + newClass;
		} else if (type === 2) {
			return currentClass.replace(newClass, '');
		}
	};
}
